'use client';

import { AwsPrisezIcon as AwsPrizes } from '@/components/icons/AwsPrisezIcon';
import { LadderIcon } from '@/components/icons/LadderIcon';
import { NextTriangleIcon as NextTriangle } from '@/components/icons/NextTriangleIcon';
import { PredictionIcon } from '@/components/icons/PredictionIcon';

export const PickemsHowItWorksSection = () => {
  const steps = [
    {
      id: 1,
      title: 'Make Prediction',
      icon: (
        <PredictionIcon
          className="size-12"
          desc="Prediction icon for making picks"
          title="Make Prediction"
        />
      ),
    },
    {
      id: 2,
      title: 'Climb up the ladder',
      icon: (
        <LadderIcon
          className="size-12"
          desc="Ladder icon for climbing rankings"
          title="Climb Ladder"
        />
      ),
    },
    {
      id: 3,
      title: 'Win awesome prizes',
      icon: (
        <AwsPrizes
          className="size-12"
          desc="Prize icon for winning rewards"
          title="Win Prizes"
        />
      ),
    },
  ];

  return (
    <div className="mt-10 flex flex-col items-start gap-6">
      <h2 className="font-semibold text-2xl">How it works</h2>
      <div className="font-semibold text-xl">
        For each correct pick you will get points.
      </div>
      <p className="max-w-[700px] text-gray-300">
        Pick your favourite teams in popular leagues and tournaments. Earn
        points for every correct prediction and climb the leaderboard to win
        exclusive rewards. Stay updated as matches unfold and see how your picks
        stack up for a chance to score big prizes!
      </p>

      <div className="relative flex w-full flex-col items-stretch justify-between lg:flex-row">
        {steps.map((step, index) => (
          <div
            className="mb-4 flex w-full items-stretch justify-around lg:w-2/5 lg:last:w-1/5"
            key={step.id}
          >
            <div className="flex w-full flex-col items-center justify-center lg:flex-row lg:items-stretch lg:justify-around">
              <div className="flex w-full flex-col items-center text-center lg:w-48">
                <div className="relative z-10">
                  <div className="-skew-x-6 -rotate-6 flex items-center justify-center border border-blue-gray-o15 bg-custom-gradient-3 py-1">
                    <p className="rotate-6 skew-x-6 px-6 py-2 font-semibold text-xl">
                      {step.id}.
                    </p>
                  </div>
                </div>
                <div className="-inset-y-3 -skew-x-6 relative flex h-full w-5/6 flex-col items-center justify-center rounded-lg bg-dark-gray px-4 py-6 lg:w-full lg:p-4">
                  <div className="mb-2 skew-x-6">{step.icon}</div>
                  <h3 className="skew-x-6 font-semibold">{step.title}</h3>
                </div>
              </div>
              {index < steps.length - 1 && <TriangleDivider />}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

function TriangleDivider() {
  return (
    <div className="flex flex-col items-center justify-center lg:mt-8 lg:flex-row lg:gap-1">
      <NextTriangle
        className="w-10 rotate-90 scale-125 lg:rotate-0"
        desc="Next step arrow icon"
        title="Next Step"
      />
      <NextTriangle
        className="rotate-90 lg:rotate-0"
        desc="Next step arrow icon"
        title="Next Step"
      />
      <NextTriangle
        className="w-10 rotate-90 scale-75 lg:rotate-0"
        desc="Next step arrow icon"
        title="Next Step"
      />
    </div>
  );
}
